"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Reveals the app's own post-quiz footer (template-parts/app/ld-single.php)
 * when an attempt finishes.
 *
 * LearnDash's "Continuar" link is gated on the score: wpProQuiz_front.js hides
 * `.quiz_continue_link` whenever the result is under the quiz's passing grade,
 * and the link it would have shown bounces back to the same quiz anyway because
 * `learndash_is_quiz_complete()` is false for a failed attempt. On the Examen
 * simulación course (6 of 7 exams cut at 80%) that left roughly half of all
 * attempts staring at a results screen with nothing to click.
 *
 * The footer is server-rendered but `hidden`, so it can't be used to skip past
 * an unanswered quiz. Two independent triggers reveal it, because the whole
 * point is not to depend on LearnDash's plumbing:
 *
 *  1. LD's own `learndash-quiz-finished` event, delegated on document. It is a
 *     jQuery-triggered custom event, so it needs a jQuery handler — a native
 *     addEventListener would never see it.
 *  2. A MutationObserver on the results box: if the event ever stops firing
 *     (it already skips one branch upstream, when `passingpercentage` is
 *     undefined), the box becoming visible still reveals the footer.
 */
class AppQuizNav {
    constructor() {
        this.nav = null;
    }
    init() {
        this.nav = document.querySelector('[data-prepain-quiz-nav]');
        if (!this.nav) {
            return;
        }
        this.bindLearnDashEvent();
        this.observeResultsBox();
    }
    /** LD fires this on the quiz element for both passed and failed attempts. */
    bindLearnDashEvent() {
        const jq = window.jQuery;
        if (!jq) {
            return;
        }
        jq(document).on('learndash-quiz-finished', () => this.reveal());
    }
    /** Fallback: the results box is `display:none` until an attempt is scored. */
    observeResultsBox() {
        const box = document.querySelector('.wpProQuiz_results');
        if (!box || typeof MutationObserver === 'undefined') {
            return;
        }
        const observer = new MutationObserver(() => {
            if (box.offsetParent !== null) {
                observer.disconnect();
                this.reveal();
            }
        });
        observer.observe(box, { attributes: true, attributeFilter: ['style', 'class'] });
    }
    reveal() {
        if (!this.nav || !this.nav.hidden) {
            return;
        }
        this.nav.hidden = false;
    }
}
exports.default = AppQuizNav;
